<template>
  <div :class="[$style.wrapper, error && $style.error]">
    <input type="text" :placeholder="placeholder" :disabled="disabled" :value="value" @input="e => $emit('input', e.target.value)">
  </div>
</template>
<script>
export default {
  name: 'v-input',
  props: {
    value: String,
    disabled: Boolean,
    placeholder: String,
    error: Boolean,
  },
}
</script>
<style lang="scss" module>
.wrapper {
  width: 29.5rem;

  & + & {
    margin-top: 1rem;
  }

  input {
    width: 100%;
    height: 6rem;
    line-height: 6rem;
    padding: 1.7rem;
    border: 2px solid #DADADA;
    outline: none;
    font-size: 1.6rem;
    border-radius: 0.5rem;
    transition: border 0.2s ease;
    appearance: none;

    &:disabled {
      background: #fff;
      color: #000;
      cursor: not-allowed;
    }
  }

  &.error {
    input {
      border-color: #ff0000;
    }
  }
}
</style>
